import React from "react";

export default props => (
  <svg
    {...props}
    viewBox="0 0 12 12"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      id="Vector"
      d="M3.563 11.282L0 12L0.719 8.4375L3.563 11.282ZM1.426 7.73L4.27 10.5745L12 2.8445L9.1555 0L1.426 7.73Z"
      fill="#EB5757"
    />
  </svg>
);



// WEBPACK FOOTER //
// ./src/nekrasovka-ui/Icons/svg/Pencil/index.js